import React from "react"
import { Link } from "@reach/router"

import Navigation from "../components/Navigation"
import Footer from "../components/Footer"

import Me from "../img/me.png"
import Animoji from "../img/animoji.png"
import Prog from "../img/prog.png"
import Creative from "../img/creative.png"

import "./style/Landing.css"

const Landing = () => {
    return (
        <div>
            <Navigation className="nav" />
            <div className="hero">
                <img src={Me} alt="vicky" className="me" draggable={false} />
                <h2 class="greeting">
                    HI! I'M VICKY LI. <br />
                    <span className="second">
                        I'M A <span className="purple">DEVELOPER & DESIGNER</span>
                    </span>
                    <br />
                    <span className="third">FROM UC BERKELEY.</span>
                </h2>
            </div>
            <div className="descriptor">
                <img
                    src={Animoji}
                    alt="animoji"
                    className="animoji"
                    draggable={false}
                />
                <div className="descriptor-text">
                    <p className="para">
                        Hey, I'm Vicky Li, I’m a{" "}
                        <span className="purple">20-year-old creator</span>.
                        Canada-born, Minnesota-raised, and now studying Computer
                        Science at UC Berkeley.
                        <br />
                    </p>
                    <p className="para middle">
                        I'm a driven{" "}
                        <span className="purple">developer and designer</span> who's
                        always ready for a challenge. I’ve never been the greatest at
                        sitting still in classes, but I find my passion through
                        creating in many forms.
                        <br />
                    </p>
                    <p className="para inner">
                        Check out my past work, and{" "}
                        <span className="purple">don't hesitate</span> to reach out
                        to me to talk about anything from CS to design to
                        minesweeper.
                    </p>
                </div>
            </div>
            <div className="specialties">
                <h2 className="purple-large">MY WORK</h2>
                <div className="specialities-row">
                    <Link to="/programming" className="blob">
                        <img src={Prog} alt="programming" draggable={false} />
                    </Link>
                    <Link to="/creative" className="blob">
                        <img src={Creative} alt="creative" draggable={false} />
                    </Link>
                </div>
            </div>
            <Footer />
        </div>
    )
}
export default Landing
